import styled from 'styled-components';

import CapsuleIcon from 'src/app/components/Elements/CapsuleIcon';
import { Typography } from 'src/app/components/Elements/Typography';

export const IconAndTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  &:not(:last-child) {
    margin-bottom: ${props => props.theme.space['1.5']} !important;
  }
`;

export const Text = styled(props => <Typography {...props} />)`
  padding-left: ${props => props.theme.space['2.0']} !important;
`;

export const StylizedCapsuleIcon = styled(props => <CapsuleIcon {...props} />)`
  svg {
    width: ${props => props.theme.space['1.8']};
  }
`;
